module.exports = __webpack_public_path__ + "img/4.35c73f8d.png";